<template>
  <!-- hideB2BLayout: To hide the New layout for Anonymous users, while accessing /tenant page -->
  <div class="bg-white">
    <div v-if="isLandscape">
      <div
        class="h-100 flex-column justify-content-between align-items-center ef-bg-dark text-center nav-wrapper overflow-auto"
        v-if="!hideB2BLayout" :style="{ display: hideB2BLayout ? 'none' : 'flex', backgroundColor: brandColor }">
        <img :src="getCorporateImage" class="mt-4 px-2" width="95px" />
        <b-nav vertical class="w-100 px-0 d-xs-none">
          <b-nav-item class="py-2" :to="`/user/main`">
            <div class="home">
              <span class="float-left">
                <svg width="5" height="55" viewBox="0 0 5 55" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 0C2.76142 0 5 2.23858 5 5V50C5 52.7614 2.76142 55 0 55V0Z" fill="none" />
                </svg>
              </span>
              <div class="d-flex flex-column">
                <div class="d-flex justify-content-center">
                  <svg width="23" height="25" viewBox="0 0 23 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M7.22901 23.7501H1.67847V11.2867C1.67847 11.1688 1.72584 11.0555 1.81045 10.9723L2.21094 10.5787C4.30854 8.51737 9.47534 3.43994 11.543 1.40791C13.6638 3.49223 19.0454 8.78071 21.0308 10.7317L21.2755 10.9723C21.2756 10.9724 21.2757 10.9725 21.2758 10.9725C21.3602 11.0557 21.4075 11.1689 21.4075 11.2867V23.7501H15.857V20.4538C15.857 19.3099 15.4025 18.2125 14.5935 17.4036C13.7844 16.5944 12.6873 16.1399 11.543 16.1399C10.3986 16.1399 9.30154 16.5944 8.49242 17.4036C7.68348 18.2125 7.22901 19.3099 7.22901 20.4538V23.7501Z"
                      stroke="#969B92" stroke-width="2.5" />
                  </svg>
                </div>
                <p class="menu-text pt-1 mb-0">{{t('navigation.home')}}</p>
              </div>
            </div>
          </b-nav-item>
          <b-nav-item class="py-2" :to="`/leaderboard`" v-if="theme[pages.LEADERBOARD].show">
            <div class="leaderboard" v-show="isCorporate && showCorpItems">
              <span class="float-left">
                <svg width="5" height="55" viewBox="0 0 5 55" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 0C2.76142 0 5 2.23858 5 5V50C5 52.7614 2.76142 55 0 55V0Z" fill="none" />
                </svg>
              </span>
              <div class="d-flex flex-column">
                <div class="d-flex justify-content-center">
                  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="2" y="2" width="22" height="21" fill="none" />
                    <path
                      d="M20.8333 25H4.16667C3.0616 25 2.00179 24.561 1.22039 23.7796C0.438987 22.9982 0 21.9384 0 20.8333V4.16667C0 3.0616 0.438987 2.00179 1.22039 1.22039C2.00179 0.438987 3.0616 0 4.16667 0H20.8333C21.9384 0 22.9982 0.438987 23.7796 1.22039C24.561 2.00179 25 3.0616 25 4.16667V20.8333C25 21.9384 24.561 22.9982 23.7796 23.7796C22.9982 24.561 21.9384 25 20.8333 25ZM4.16667 2.77778C3.79831 2.77778 3.44504 2.92411 3.18457 3.18457C2.92411 3.44504 2.77778 3.79831 2.77778 4.16667V20.8333C2.77778 21.2017 2.92411 21.555 3.18457 21.8154C3.44504 22.0759 3.79831 22.2222 4.16667 22.2222H20.8333C21.2017 22.2222 21.555 22.0759 21.8154 21.8154C22.0759 21.555 22.2222 21.2017 22.2222 20.8333V4.16667C22.2222 3.79831 22.0759 3.44504 21.8154 3.18457C21.555 2.92411 21.2017 2.77778 20.8333 2.77778H4.16667Z"
                      fill="#969B92" />
                    <path
                      d="M8.3333 11.1111C8.15039 11.113 7.96895 11.0783 7.7996 11.0092C7.63025 10.94 7.47641 10.8378 7.34706 10.7084C7.21772 10.5791 7.11549 10.4252 7.04635 10.2559C6.97721 10.0866 6.94255 9.90512 6.94441 9.72221C6.94643 9.35385 7.09075 9.00054 7.34718 8.7361C7.60872 8.47456 7.96343 8.32764 8.3333 8.32764C8.70316 8.32764 9.05787 8.47456 9.31941 8.7361C9.58094 8.99763 9.72787 9.35234 9.72787 9.72221C9.72787 10.0921 9.58094 10.4468 9.31941 10.7083C9.05457 10.9641 8.70151 11.1084 8.3333 11.1111Z"
                      fill="#969B92" />
                    <path
                      d="M16.6667 11.1113H13.8889C13.5205 11.1113 13.1673 10.9649 12.9068 10.7045C12.6463 10.444 12.5 10.0907 12.5 9.72238C12.5 9.35403 12.6463 9.00076 12.9068 8.74029C13.1673 8.47983 13.5205 8.3335 13.8889 8.3335H16.6667C17.035 8.3335 17.3883 8.47983 17.6488 8.74029C17.9092 9.00076 18.0556 9.35403 18.0556 9.72238C18.0556 10.0907 17.9092 10.444 17.6488 10.7045C17.3883 10.9649 17.035 11.1113 16.6667 11.1113Z"
                      fill="#969B92" />
                    <path
                      d="M8.33325 16.6667C7.96552 16.6616 7.6133 16.5177 7.34714 16.2639C7.0907 15.9995 6.94639 15.6462 6.94436 15.2778C6.94276 15.002 7.02334 14.7319 7.17584 14.502C7.32834 14.2721 7.54585 14.0928 7.80063 13.987C8.05542 13.8812 8.33593 13.8537 8.60642 13.908C8.8769 13.9623 9.12509 14.0958 9.31936 14.2917C9.57757 14.555 9.72221 14.9091 9.72221 15.2778C9.72221 15.6466 9.57757 16.0007 9.31936 16.2639L9.11103 16.4306C9.03347 16.4829 8.94943 16.525 8.86103 16.5556C8.78225 16.5955 8.69801 16.6236 8.61103 16.6389C8.51924 16.655 8.4264 16.6643 8.33325 16.6667Z"
                      fill="#969B92" />
                    <path
                      d="M16.6667 16.6665H13.8889C13.5205 16.6665 13.1673 16.5201 12.9068 16.2597C12.6463 15.9992 12.5 15.6459 12.5 15.2776C12.5 14.9092 12.6463 14.5559 12.9068 14.2955C13.1673 14.035 13.5205 13.8887 13.8889 13.8887H16.6667C17.035 13.8887 17.3883 14.035 17.6488 14.2955C17.9092 14.5559 18.0556 14.9092 18.0556 15.2776C18.0556 15.6459 17.9092 15.9992 17.6488 16.2597C17.3883 16.5201 17.035 16.6665 16.6667 16.6665Z"
                      fill="#969B92" />
                  </svg>
                </div>
                <p class="menu-text pt-1 mb-0">{{ t(`page.${theme[pages.LEADERBOARD].name}`) }}</p>
              </div>
            </div>
          </b-nav-item>
          <b-nav-item class="py-2" :to="`/progress`" v-if="theme[pages.PROGRESS].show">
            <div class="progress-tab">
              <span class="float-left">
                <svg width="5" height="55" viewBox="0 0 5 55" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 0C2.76142 0 5 2.23858 5 5V50C5 52.7614 2.76142 55 0 55V0Z" fill="none" />
                </svg>
              </span>
              <div class="d-flex flex-column">
                <div class="d-flex justify-content-center">
                  <svg width="23" height="25" viewBox="0 0 23 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M11.5561 8.7198V6.52952C8.05056 6.52397 4.92001 9.04202 4.2589 12.6448C3.60474 16.2045 5.55751 19.717 8.90194 20.9975C9.85888 21.3642 10.3394 22.442 9.97694 23.4086C9.65472 24.267 8.77278 24.7461 7.91028 24.585C7.80195 24.5656 7.69361 24.535 7.58806 24.4947C2.56724 22.5753 -0.364692 17.3045 0.617249 11.9656C1.60891 6.56425 6.30195 2.80176 11.5561 2.8087V0.993432C11.5561 0.122602 12.6519 -0.326008 13.3158 0.275379L17.5852 4.13787C18.0172 4.52953 18.0172 5.18509 17.5852 5.57675L13.3158 9.43924C12.6519 10.0392 11.5561 9.59202 11.5561 8.7198ZM14.0047 21.0573C13.7297 21.1573 13.4464 21.2406 13.1603 21.3045C12.1617 21.5281 11.5297 22.5267 11.7505 23.535C11.9158 24.2906 12.513 24.8364 13.2214 24.9697C13.4589 25.0128 13.7089 25.0114 13.9589 24.9559C14.395 24.8572 14.8241 24.7322 15.2436 24.5822C16.2061 24.2364 16.7116 23.1656 16.37 22.1934C16.0269 21.2198 14.9658 20.7114 14.0047 21.0573ZM17.6866 18.1809C17.6075 18.3003 17.5255 18.417 17.438 18.5309C16.8144 19.3489 16.9644 20.5225 17.7755 21.1531C18.0172 21.3392 18.2866 21.4573 18.5672 21.5086C19.2283 21.6323 19.9339 21.3864 20.3741 20.81C20.5061 20.635 20.6352 20.4545 20.7588 20.2698C21.3297 19.4128 21.1061 18.2517 20.2589 17.6739C19.4102 17.1003 18.2589 17.3239 17.6866 18.1809ZM20.8477 12.4448C19.8255 12.417 18.9727 13.2684 18.9464 14.3017C18.9214 15.2309 19.5741 16.0059 20.4519 16.1698C20.5464 16.1878 20.645 16.1989 20.7436 16.2003C21.7644 16.2309 22.6172 15.4017 22.6491 14.3698C22.6491 14.367 22.6505 14.3295 22.6505 14.3267C22.6783 13.2934 21.863 12.4628 20.8477 12.4448Z"
                      fill="#969B92" />
                  </svg>
                </div>
                <p class="menu-text pt-1 mb-0">{{ t(`page.${theme[pages.PROGRESS].name}`) }}</p>
              </div>
            </div>
          </b-nav-item>
          <b-nav-item class="py-2" :to="`/achievements`" v-if="showAchievements">
            <div class="progress-tab">
              <span class="float-left">
                <svg width="5" height="55" viewBox="0 0 5 55" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 0C2.76142 0 5 2.23858 5 5V50C5 52.7614 2.76142 55 0 55V0Z" fill="none" />
                </svg>
              </span>
              <div class="d-flex flex-column">
                <div class="d-flex justify-content-center">
                  <svg width="23" height="25" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" fill="#969B92"
                      d="M2.5.5A.5.5 0 0 1 3 0h10a.5.5 0 0 1 .5.5q0 .807-.034 1.536a3 3 0 1 1-1.133 5.89c-.79 1.865-1.878 2.777-2.833 3.011v2.173l1.425.356c.194.048.377.135.537.255L13.3 15.1a.5.5 0 0 1-.3.9H3a.5.5 0 0 1-.3-.9l1.838-1.379c.16-.12.343-.207.537-.255L6.5 13.11v-2.173c-.955-.234-2.043-1.146-2.833-3.012a3 3 0 1 1-1.132-5.89A33 33 0 0 1 2.5.5m.099 2.54a2 2 0 0 0 .72 3.935c-.333-1.05-.588-2.346-.72-3.935m10.083 3.935a2 2 0 0 0 .72-3.935c-.133 1.59-.388 2.885-.72 3.935" />
                  </svg>
                </div>
                <p class="menu-text pt-1 mb-0">{{ t(`page.${theme[pages.Achievements].name}`) }}</p>
              </div>
            </div>
          </b-nav-item>
          <b-nav-item class="py-2 position-relative overflow-hidden" :to="`/user/assessment`">
            <div class="cover" v-if="user">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="20" width="20" ><path d="M12 2a4 4 0 0 0-4 4v4H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-2V6a4 4 0 0 0-4-4zm-2 6V6a2 2 0 0 1 4 0v4h-4zm10 12H6v-8h12v8z" /></svg>
            </div>
            <div class="progress-tab">
              <span class="float-left">
                <svg width="5" height="55" viewBox="0 0 5 55" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 0C2.76142 0 5 2.23858 5 5V50C5 52.7614 2.76142 55 0 55V0Z" fill="none" />
                </svg>
              </span>
              <div class="d-flex flex-column">
                <div class="d-flex justify-content-center">
                  <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="30" height="30">
                    <path d="M0 0 C1.98 0 3.96 0 6 0 C6 0.99 6 1.98 6 3 C8.31 3 10.62 3 13 3 C13 10.92 13 18.84 13 27 C6.4 27 -0.2 27 -7 27 C-7 19.08 -7 11.16 -7 3 C-4.69 3 -2.38 3 0 3 C0 2.01 0 1.02 0 0 Z M-4 5 C-5.5220959 6.5220959 -5.12959521 7.88210082 -5.1328125 10 C-5.13410156 10.804375 -5.13539062 11.60875 -5.13671875 12.4375 C-5.13285156 13.283125 -5.12898437 14.12875 -5.125 15 C-5.12886719 15.845625 -5.13273438 16.69125 -5.13671875 17.5625 C-5.13542969 18.366875 -5.13414063 19.17125 -5.1328125 20 C-5.13168457 20.7425 -5.13055664 21.485 -5.12939453 22.25 C-5.18942216 24.02825811 -5.18942216 24.02825811 -4 25 C-1.66839945 25.09909302 0.66629942 25.12970504 3 25.125 C4.27875 25.12757812 5.5575 25.13015625 6.875 25.1328125 C9.86687244 25.35860893 9.86687244 25.35860893 11 24 C11.08631874 22.65732587 11.10706473 21.31025678 11.09765625 19.96484375 C11.09282227 18.75151367 11.09282227 18.75151367 11.08789062 17.51367188 C11.07951172 16.66353516 11.07113281 15.81339844 11.0625 14.9375 C11.05798828 14.08349609 11.05347656 13.22949219 11.04882812 12.34960938 C11.03700373 10.23304337 11.01906769 8.11651315 11 6 C9.35 5.67 7.7 5.34 6 5 C6 5.66 6 6.32 6 7 C4.02 7 2.04 7 0 7 C0 6.34 0 5.68 0 5 C-1.32 5 -2.64 5 -4 5 Z " fill="#969B92" transform="translate(12,0)"/>
                    <path d="M0 0 C1.98 0 3.96 0 6 0 C6 0.66 6 1.32 6 2 C4.02 2 2.04 2 0 2 C0 1.34 0 0.68 0 0 Z " fill="#969B92" transform="translate(10,19)"/>
                    <path d="M0 0 C1.98 0 3.96 0 6 0 C6 0.66 6 1.32 6 2 C4.02 2 2.04 2 0 2 C0 1.34 0 0.68 0 0 Z " fill="#969B92" transform="translate(10,15)"/>
                    <path d="M0 0 C1.98 0 3.96 0 6 0 C6 0.66 6 1.32 6 2 C4.02 2 2.04 2 0 2 C0 1.34 0 0.68 0 0 Z " fill="#969B92" transform="translate(10,11)"/>
                    <path d="M0 0 C0.66 0 1.32 0 2 0 C2 0.66 2 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z " fill="#969B92" transform="translate(18,19)"/>
                    <path d="M0 0 C0.66 0 1.32 0 2 0 C2 0.66 2 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z " fill="#969B92" transform="translate(18,15)"/>
                    <path d="M0 0 C0.66 0 1.32 0 2 0 C2 0.66 2 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z " fill="#969B92" transform="translate(18,11)"/>
                  </svg>
                </div>
                <p class="menu-text pt-1 mb-0">{{t(`page.${theme[pages.Assessment].name}`)}}</p>
              </div>
            </div>
          </b-nav-item>
          <b-nav-item class="py-2" :to="`/social`" v-if="hasSocialAccess">
            <div class="social-tab">
              <span class="float-left">
                <svg width="5" height="55" viewBox="0 0 5 55" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 0C2.76142 0 5 2.23858 5 5V50C5 52.7614 2.76142 55 0 55V0Z" fill="none" />
                </svg>
              </span>
              <div class="d-flex flex-column">
                <div class="d-flex justify-content-center">
                  <b-icon icon="people" font-scale="2"></b-icon>
                </div>
                <p class="menu-text pt-1 mb-0">{{t(`navigation.social`)}}</p>
              </div>
            </div>
          </b-nav-item>
          <b-nav-item class="d-none py-2"><img src="../../assets/icons/my-list.svg" />
            <p class=" pt-1 mb-0">{{t(`navigation.myList`)}}</p>
          </b-nav-item>
        </b-nav>
        <img :src="navDownImage" class="mb-3 w-50" />
      </div>
    </div>

    <div class="content-menu d-flex flex-column w-md-100" :style="contentWidth">
      <header class="ef-bg-gray" v-if="!hideB2BLayout">
        <b-row class="my-2 my-lg-0 mx-0 d-flex justify-content-between align-items-center ef-bg-gray"
          v-if="screen > 768">
          <div class="text-center">
            <b-nav class="pl-2 pt-2" v-if="!isTitle && !isPhysiotherapy">
              <router-link :to="'/user/main'" class="mx-0 mx-md-1 mx-lg-2 text-active header-item"
                v-if="showDiscover"><label class="text-gray ef-cursor-pointer"><b>{{t('navigation.dashboard')}}</b></label></router-link>
              <router-link :to="`/user/programs`" class="mx-0 mx-md-1 mx-lg-2 text-active header-item"
                v-show="isCorporate && showCorpItems"><label class="text-gray ef-cursor-pointer text-uppercase"><b>{{
                  t(`page.${theme[pages.PROGRAMS].name}`) }}s</b></label></router-link>
              <router-link :to="'/user/discover'" class="mx-0 mx-md-1 mx-lg-2 text-active header-item"><label
                  class="text-gray ef-cursor-pointer"><b>{{t('navigation.discover')}}</b></label></router-link>
            </b-nav>
            <div v-else-if="isTitle"
              class="w-100 pt-2 pl-3 ml-3 color-primary pb-4 d-flex flex-row justify-content-start align-items-center ef-cursor-pointer line-height-24 font-weight-700 font-size-16">
              <span class="text-dark ml-0 font-size-24 font-weight-bold" style="font-size: 24px">{{ title }}</span>
            </div>
          </div>
          <div class='d-flex justify-content-end align-item-center z10 pl-4 dynamic_changes'>
            <div class="ml-0 ml-lg-2 d-flex flex-row justify-content-start align-items-center py-2">
              <LanguageSwitcher :show-label="false" :light-theme="false" :lang="language"></LanguageSwitcher>
            </div>

            <div v-if="!isCorporate" class="buy-plan-button"><button :disabled="paymentLoading" class="btn"
                @click="upgradeAccount">
                <b-icon icon="arrow-up"></b-icon> {{t(`header.upgradeAccount`)}}
              </button></div>
            <div class="notification-dropdown" v-if="!this.isAnonymous && showNotificationIcon">
              <b-dropdown size="lg" ref="notificationDropdown" class="notification-dropdown-menu" variant="link"
                toggle-class="text-decoration-none" id="dropdown-right" right text="Right align" no-caret>
                <template #button-content>
                  <b-icon class="search-icon" icon="bell-fill" @click="listOfUserNotification()"></b-icon>
                  <span v-if="unreadCount > 0" class="notification-badge">{{ unreadCount }}</span>
                </template>
                <div class="card border-0 text-left notification-card shadow">
                  <div class="card-header d-flex justify-content-between align-items-center text-white">
                    <h5 class="card-title mb-0">{{t(`header.notifications.title`)}}</h5>
                    <b-btn v-if="unreadCount > 0" variant="link" class="p-0 mr-2 text-decoration-underline btn-primary text-nowrap" @click="readAllNotifications">{{t(`header.notifications.readAll`)}}</b-btn>
                  </div>
                  <div class="card-body">
                    <div class="card-item mb-3 p-3 rounded"
                      :class="notification.status === 'sent' ? 'bg-success-subtle unread' : 'bg-white read'"
                      v-for="(notification, index) in NotificationData" :key="index">
                      <div class="d-flex justify-content-between align-items-center">
                        <div>
                          <h6 class="card-subtitle font-weight-bold mb-1">{{ notification.title }}</h6>
                          <p class="card-text text-muted mb-0"> <template v-for="(line, index) in notification.notification ? notification.notification.split('\n') : []">
                            {{ line }}<br v-if="index !== (notification.notification ? notification.notification.split('\n').length : 0) - 1" />
                          </template></p> 
                        </div>
                        <div v-if="notification.status === 'sent'" v-b-tooltip.hover :title="t(`header.notifications.markAsRead`)"
                          class="font-16 line-height-24 ef-dark ef-cursor-pointer text-uppercase">
                          <b-button id="String(notification.notifiId)" variant="text" class="p-0 btn-icon"
                            @click="updateNotificationStatus(notification.notifiId)">
                            <b-icon icon="check-circle" font-scale="1.5" class="text-success"></b-icon>
                          </b-button></div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-dropdown>

            </div>
            <div class="d-flex flex-row justify-content-end align-items-center text-center my-2 my-lg-3 mr-2">
            </div>
            <div class="d-flex flex-row justify-content-end align-items-center text-center my-2 my-lg-3 mr-2 mr-lg-4">
              <div class="rounded-circle p-2 ef-bg-green d-none">
                <img src="../../assets/icons/search.svg" />
              </div>
              <HeaderDropdown if="!isAnonymous" />
            </div>
          </div>
        </b-row>
        <b-row class="my-2 my-lg-0 mx-0 d-flex justify-content-evenly flex-column align-items-center ef-bg-gray" v-else>
          <div class='d-flex justify-content-between align-item-center z10 w-100 px-4'>
            <div class="ml-0 ml-lg-2 d-flex flex-row justify-content-start align-items-center py-2">
              <LanguageSwitcher :show-label="false" :light-theme="false" :lang="language"></LanguageSwitcher>
            </div>
            <div class="d-flex">
              <div class="notification-dropdown" v-if="!this.isAnonymous && showNotificationIcon">
                <b-dropdown size="lg"  ref="notificationDropdown" class="notification-dropdown-menu" variant="link"
                  toggle-class="text-decoration-none p-0" id="dropdown-right" right text="Right align" no-caret>
                  <template #button-content>
                    <b-icon class="search-icon" icon="bell-fill" @click="listOfUserNotification()"></b-icon>
                  </template>
                  <div class="card border-0 text-left" style="width: 30rem;">
                    <h5 class="card-title">{{t(`header.notifications.title`)}}</h5>
                    <div class="card-body">
                      <div class="card-item" v-for="(notification, index) in NotificationData" :key="index">
                        <h6 class="card-subtitle mb-2 text-muted">{{ notification.title }}</h6>
                        <p class="card-text">{{ notification.notification }}</p>
                        <!-- <a href="#" class="card-link">Card link</a>
                        <a href="#" class="card-link">Another link</a> -->
                      </div>
                    </div>
                  </div>
                </b-dropdown>

              </div>
              <div class="d-flex flex-row justify-content-end align-items-center text-center my-2 my-lg-3">
                <div class="rounded-circle p-2 ef-bg-green d-none">
                  <img src="../../assets/icons/search.svg" />
                </div>
                <HeaderDropdown if="!isAnonymous" />
              </div>
            </div>
          </div>
          <div class="text-center pb-1 w-100">
            <b-nav class="pt-1 pt-lg-4 w-100 d-flex align-item-center justify-content-between px-4"
              v-if="!isTitle && !isPhysiotherapy">
              <router-link :to="'/user/main'" class="mx-0 mx-md-1 mx-lg-2 text-active" v-if="showDiscover"><label
                  class="text-gray ef-cursor-pointer"><b>{{t('navigation.dashboard')}}</b></label></router-link>
              <router-link :to="`/user/programs`" class="mx-0 mx-md-1 mx-lg-2 text-active"
                v-show="isCorporate && showCorpItems"><label class="text-gray ef-cursor-pointer text-uppercase"><b>{{
                t(`page.${theme[pages.PROGRAMS].name}`) }}s</b></label></router-link>
              <router-link :to="'/user/discover'" class="mx-0 mx-md-1 mx-lg-2 text-active"><label
                  class="text-gray ef-cursor-pointer"><b>{{t('navigation.discover')}}</b></label></router-link>
            </b-nav>
            <div v-else-if="isTitle"
              class="w-100 pt-2 pl-3 ml-3 color-primary pb-4 d-flex flex-row justify-content-start align-items-center ef-cursor-pointer line-height-24 font-weight-700 font-size-16">
              <span class="text-dark ml-0 font-size-24 font-weight-bold" style="font-size: 24px">{{ title }}</span>
            </div>
          </div>
        </b-row>
      </header>
      <!-- <b-row class="my-2 my-lg-0 mx-0 d-flex justify-content-between align-items-center ef-bg-gray"
        v-if="desktopBanner || mobileBanner">
        <image-banner :banner-link="bannerLink" :desktop-banner="desktopBanner" :mobile-banner="mobileBanner"
          :showChallengesBanner="showChallengesBanner" />
      </b-row> -->
      <div class="position-relative w-100 h-100 overflow-auto">

        <div class="content-wrapper" id="content-wrapper"
          :class="{ 'content-wrapper-bottom': !isLandscape && isMobile && !isAnonymous }">
          <template v-if="showPopup"><Popup /></template>
          <ScrollMonitor @onBottom="onBottom">
            <b-row class="my-2 my-lg-0 mx-0 d-flex justify-content-between align-items-center ef-bg-gray"
              v-if="desktopBanner || mobileBanner">
              <image-banner :banner-link="bannerLink" :desktop-banner="desktopBanner" :mobile-banner="mobileBanner"
                :showChallengesBanner="showChallengesBanner" />
            </b-row>
            <router-view scroll-track ref="routerViewRef" />
          </ScrollMonitor>
        </div>
      </div>
    </div>
    <div v-if="!hideB2BLayout && !isLandscape">
      <div
        class="vw-100 p-0 m-0 d-flex flex-row justify-content-between align-items-center ef-bg-dark text-center  mobile-nav-wrapper"
        :style="{ backgroundColor: brandColor }">
        <b-nav class="w-100 p-0 d-flex flex-row justify-content-center align-items-center px-0 px-lg-3">
          <b-nav-item :to="`/user/main`">
            <div class="home">
              <div class="d-flex justify-content-center">
                <svg width="23" height="25" viewBox="0 0 23 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M7.22901 23.7501H1.67847V11.2867C1.67847 11.1688 1.72584 11.0555 1.81045 10.9723L2.21094 10.5787C4.30854 8.51737 9.47534 3.43994 11.543 1.40791C13.6638 3.49223 19.0454 8.78071 21.0308 10.7317L21.2755 10.9723C21.2756 10.9724 21.2757 10.9725 21.2758 10.9725C21.3602 11.0557 21.4075 11.1689 21.4075 11.2867V23.7501H15.857V20.4538C15.857 19.3099 15.4025 18.2125 14.5935 17.4036C13.7844 16.5944 12.6873 16.1399 11.543 16.1399C10.3986 16.1399 9.30154 16.5944 8.49242 17.4036C7.68348 18.2125 7.22901 19.3099 7.22901 20.4538V23.7501Z"
                    stroke="#969B92" stroke-width="2.5" />
                </svg>
              </div>
              <p class="text-gray line-height-18 font-12 mb-0">
                {{t('navigation.home')}}
              </p>
            </div>
          </b-nav-item>
          <b-nav-item :to="`/leaderboard`" v-show="isCorporate && showCorpItems && theme[pages.LEADERBOARD].show">
            <div class="leaderboard">
              <div class="d-flex justify-content-center">
                <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="2" y="2" width="22" height="21" fill="none" />
                  <path
                    d="M20.8333 25H4.16667C3.0616 25 2.00179 24.561 1.22039 23.7796C0.438987 22.9982 0 21.9384 0 20.8333V4.16667C0 3.0616 0.438987 2.00179 1.22039 1.22039C2.00179 0.438987 3.0616 0 4.16667 0H20.8333C21.9384 0 22.9982 0.438987 23.7796 1.22039C24.561 2.00179 25 3.0616 25 4.16667V20.8333C25 21.9384 24.561 22.9982 23.7796 23.7796C22.9982 24.561 21.9384 25 20.8333 25ZM4.16667 2.77778C3.79831 2.77778 3.44504 2.92411 3.18457 3.18457C2.92411 3.44504 2.77778 3.79831 2.77778 4.16667V20.8333C2.77778 21.2017 2.92411 21.555 3.18457 21.8154C3.44504 22.0759 3.79831 22.2222 4.16667 22.2222H20.8333C21.2017 22.2222 21.555 22.0759 21.8154 21.8154C22.0759 21.555 22.2222 21.2017 22.2222 20.8333V4.16667C22.2222 3.79831 22.0759 3.44504 21.8154 3.18457C21.555 2.92411 21.2017 2.77778 20.8333 2.77778H4.16667Z"
                    fill="#969B92" />
                  <path
                    d="M8.3333 11.1111C8.15039 11.113 7.96895 11.0783 7.7996 11.0092C7.63025 10.94 7.47641 10.8378 7.34706 10.7084C7.21772 10.5791 7.11549 10.4252 7.04635 10.2559C6.97721 10.0866 6.94255 9.90512 6.94441 9.72221C6.94643 9.35385 7.09075 9.00054 7.34718 8.7361C7.60872 8.47456 7.96343 8.32764 8.3333 8.32764C8.70316 8.32764 9.05787 8.47456 9.31941 8.7361C9.58094 8.99763 9.72787 9.35234 9.72787 9.72221C9.72787 10.0921 9.58094 10.4468 9.31941 10.7083C9.05457 10.9641 8.70151 11.1084 8.3333 11.1111Z"
                    fill="#969B92" />
                  <path
                    d="M16.6667 11.1113H13.8889C13.5205 11.1113 13.1673 10.9649 12.9068 10.7045C12.6463 10.444 12.5 10.0907 12.5 9.72238C12.5 9.35403 12.6463 9.00076 12.9068 8.74029C13.1673 8.47983 13.5205 8.3335 13.8889 8.3335H16.6667C17.035 8.3335 17.3883 8.47983 17.6488 8.74029C17.9092 9.00076 18.0556 9.35403 18.0556 9.72238C18.0556 10.0907 17.9092 10.444 17.6488 10.7045C17.3883 10.9649 17.035 11.1113 16.6667 11.1113Z"
                    fill="#969B92" />
                  <path
                    d="M8.33325 16.6667C7.96552 16.6616 7.6133 16.5177 7.34714 16.2639C7.0907 15.9995 6.94639 15.6462 6.94436 15.2778C6.94276 15.002 7.02334 14.7319 7.17584 14.502C7.32834 14.2721 7.54585 14.0928 7.80063 13.987C8.05542 13.8812 8.33593 13.8537 8.60642 13.908C8.8769 13.9623 9.12509 14.0958 9.31936 14.2917C9.57757 14.555 9.72221 14.9091 9.72221 15.2778C9.72221 15.6466 9.57757 16.0007 9.31936 16.2639L9.11103 16.4306C9.03347 16.4829 8.94943 16.525 8.86103 16.5556C8.78225 16.5955 8.69801 16.6236 8.61103 16.6389C8.51924 16.655 8.4264 16.6643 8.33325 16.6667Z"
                    fill="#969B92" />
                  <path
                    d="M16.6667 16.6665H13.8889C13.5205 16.6665 13.1673 16.5201 12.9068 16.2597C12.6463 15.9992 12.5 15.6459 12.5 15.2776C12.5 14.9092 12.6463 14.5559 12.9068 14.2955C13.1673 14.035 13.5205 13.8887 13.8889 13.8887H16.6667C17.035 13.8887 17.3883 14.035 17.6488 14.2955C17.9092 14.5559 18.0556 14.9092 18.0556 15.2776C18.0556 15.6459 17.9092 15.9992 17.6488 16.2597C17.3883 16.5201 17.035 16.6665 16.6667 16.6665Z"
                    fill="#969B92" />
                </svg>
              </div>
              <p class="text-gray line-height-18 font-12">
                {{ t(`page.${theme[pages.LEADERBOARD].name}`) }}
              </p>
            </div>
          </b-nav-item>
          <b-nav-item :to="`/progress`" v-if="theme[pages.PROGRESS].show">
            <div class="progress-tab">
              <div class="d-flex justify-content-center">
                <svg width="23" height="25" viewBox="0 0 23 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M11.5561 8.7198V6.52952C8.05056 6.52397 4.92001 9.04202 4.2589 12.6448C3.60474 16.2045 5.55751 19.717 8.90194 20.9975C9.85888 21.3642 10.3394 22.442 9.97694 23.4086C9.65472 24.267 8.77278 24.7461 7.91028 24.585C7.80195 24.5656 7.69361 24.535 7.58806 24.4947C2.56724 22.5753 -0.364692 17.3045 0.617249 11.9656C1.60891 6.56425 6.30195 2.80176 11.5561 2.8087V0.993432C11.5561 0.122602 12.6519 -0.326008 13.3158 0.275379L17.5852 4.13787C18.0172 4.52953 18.0172 5.18509 17.5852 5.57675L13.3158 9.43924C12.6519 10.0392 11.5561 9.59202 11.5561 8.7198ZM14.0047 21.0573C13.7297 21.1573 13.4464 21.2406 13.1603 21.3045C12.1617 21.5281 11.5297 22.5267 11.7505 23.535C11.9158 24.2906 12.513 24.8364 13.2214 24.9697C13.4589 25.0128 13.7089 25.0114 13.9589 24.9559C14.395 24.8572 14.8241 24.7322 15.2436 24.5822C16.2061 24.2364 16.7116 23.1656 16.37 22.1934C16.0269 21.2198 14.9658 20.7114 14.0047 21.0573ZM17.6866 18.1809C17.6075 18.3003 17.5255 18.417 17.438 18.5309C16.8144 19.3489 16.9644 20.5225 17.7755 21.1531C18.0172 21.3392 18.2866 21.4573 18.5672 21.5086C19.2283 21.6323 19.9339 21.3864 20.3741 20.81C20.5061 20.635 20.6352 20.4545 20.7588 20.2698C21.3297 19.4128 21.1061 18.2517 20.2589 17.6739C19.4102 17.1003 18.2589 17.3239 17.6866 18.1809ZM20.8477 12.4448C19.8255 12.417 18.9727 13.2684 18.9464 14.3017C18.9214 15.2309 19.5741 16.0059 20.4519 16.1698C20.5464 16.1878 20.645 16.1989 20.7436 16.2003C21.7644 16.2309 22.6172 15.4017 22.6491 14.3698C22.6491 14.367 22.6505 14.3295 22.6505 14.3267C22.6783 13.2934 21.863 12.4628 20.8477 12.4448Z"
                    fill="#969B92" />
                </svg>
              </div>
              <p class="text-gray line-height-18 font-12"> {{ t(`page.${theme[pages.PROGRESS].name}`) }}</p>
            </div>
          </b-nav-item>
          <b-nav-item :to="`/achievements`" v-if="showAchievements">
            <div class="progress-tab">
              <div class="d-flex justify-content-center">
                <svg width="23" height="25" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" fill="#969B92"
                    d="M2.5.5A.5.5 0 0 1 3 0h10a.5.5 0 0 1 .5.5q0 .807-.034 1.536a3 3 0 1 1-1.133 5.89c-.79 1.865-1.878 2.777-2.833 3.011v2.173l1.425.356c.194.048.377.135.537.255L13.3 15.1a.5.5 0 0 1-.3.9H3a.5.5 0 0 1-.3-.9l1.838-1.379c.16-.12.343-.207.537-.255L6.5 13.11v-2.173c-.955-.234-2.043-1.146-2.833-3.012a3 3 0 1 1-1.132-5.89A33 33 0 0 1 2.5.5m.099 2.54a2 2 0 0 0 .72 3.935c-.333-1.05-.588-2.346-.72-3.935m10.083 3.935a2 2 0 0 0 .72-3.935c-.133 1.59-.388 2.885-.72 3.935" />
                </svg>
              </div>
              <p class="text-gray line-height-18 font-12">{{ t(`page.${theme[pages.Achievements].name}`) }}</p>
            </div>
          </b-nav-item>
          <b-nav-item :to="`/social`" v-if="hasSocialAccess">
            <div class="social">
              <div class="d-flex justify-content-center">
                <b-icon icon="people" font-scale="1.5"></b-icon>
              </div>
              <p class="text-gray line-height-18 font-12 mb-0">
                {{ t(`navigation.social`) }}
              </p>
            </div>
          </b-nav-item>
          <b-nav-item class="d-none"><img src="../../assets/icons/my-list.svg" />
            <p class="text-gray line-height-18 font-12">{{ t(`navigation.myList`) }}</p>
          </b-nav-item>
        </b-nav>
      </div>
    </div>
    <div class="" v-if="!hideFriendsActivity">
      <div :style="{ backgroundColor: friendsActivityColor }"
        class="d-none d-lg-block vh-100 ef-bg-dark friend-activity overflow-auto" id="friend-activity">
        <label class="text-gray line-height-24 font-16 font-weight-bold mt-4 ml-2">
          {{ friendsActivityLabel }}
        </label>
        <span v-if="friendsActivityData.length == 0" class="w-100 d-flex flex-column justify-content-start pt-1">
          <label class="ef-white line-height-21 font-14 font-weight-bold d-flex justify-content-center">{{ t(`friendsActivity.noActivity`) }}</label></span>
        <div class="w-100 d-flex d-row justify-content-start align-center-start mt-2"
          v-for="(friend, index) in friendsActivityData" :key="index">
          <template v-if="friend.user_name || friend.email">
            <img src="@/assets/images/default-avatar.jpeg" width="45" height="45" class="p-2" />
            <span class="w-100 d-flex flex-column justify-content-start pt-1">
              <label class="ef-white line-height-21 font-14 font-weight-bold d-flex justify-content-between notranslate"
                data-toggle="tooltip" :title="friend.user_name">{{ friend.user_name || friend.email.split("@")[0] |
                  limitName }}
                <span class="text-gray font-12 font-weight-500 line-height-18 pr-2 notranslate">{{ friend.created_at |
                  getDayFormat }}</span></label>
              <label class="ef-white line-height-18 font-weight-500" data-toggle="tooltip"
                :title="friend.workout_title">{{ friend.workout_title | limitTitle }}</label>
              <label><span v-if="friend.workout_category && friend.workout_category.length > 0"
                  class="font-12 line-height-18 color-primary border-green px-3 font-weight-500 rounded"
                  data-toggle="tooltip" :title="friend.workout_category[0].category_name"
                  @click="getSimilargetCategoriesVideos(friend.workout_category[0].category_id)">{{
                    friend.workout_category[0].category_name
                    | limitName }}</span><span class="d-none px-2 text-gray">&bull; </span><span
                  class="d-none ef-white line-height-18 font-12 font-weight-bold">{{ t(`friendsActivity.noActivity`) }}</span></label>
            </span>
          </template>
        </div>
      </div>
    </div>
    <TryPopup />
    <UpgradeAccountPopup :is-open="!!askedForUpgradeAccountPopup" :on-cancel-return="onCancelUpgradeAccountReturn"
      @onVerified="hideUpgradeAccountPopup" @onCancel="hideUpgradeAccountPopup" />
  </div>
</template>
<script>
import { createNamespacedHelpers, mapGetters } from "vuex";
import navDownImage from "@/assets/elitefit-logo-white.png";
import CodeInput from "vue-verification-code-input";
import api from "../../api/api";
import ImageBanner from "@/components/ImageBanner";
import TryPopup from "@/module_b2b_users/components/TryPopup/TryPopup";
import Popup from "@/module_b2b_users/views/Popup.vue";
import UpgradeAccountPopup from "@/module_user/components/Discover/UpgradeAccountPopup.vue";
import LanguageSwitcher from "@/components/LanguageSwitcher";
import BigCrossIcon from "@/module_b2b_users/assets/icons/big-cross.svg";
import ScrollMonitor from "@/components/ScrollMonitor";
import HeaderDropdown from "@/components/HeaderDropdown";
import { mapState, mapActions } from 'vuex';
const {
  mapGetters: mapThemeGetters,
  mapMutations: mapThemeMutations
} = createNamespacedHelpers("themes");
const {
  mapActions: challengesActions,
  mapState: challengesState,
} = createNamespacedHelpers("b2bUser/challenges");
const { mapActions: b2bActions, mapState: b2bState } = createNamespacedHelpers(
  "b2bUser"
);
const { mapActions: mapDashboardAction, mapState: mapDashboardState, mapMutations: mapDashboardMutations } = createNamespacedHelpers(
  "user/dashboard"
);

const {
  mapState: trainerState,
} = createNamespacedHelpers("user/trainerProfile");

const {
  mapActions: b2bTrainerActions,
} = createNamespacedHelpers("b2bUser/trainerProfile");
import API from "../../../module_admin/api.js"
import b2bService from "@/module_user/api/b2b-service";
import { i18nComponentMixin } from "@/i18n/mixin";

const monthList = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]

function debounce(func, delay) {
  let timeoutId;

  return function (...args) {
    clearTimeout(timeoutId);

    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}

export default {
  props: ["search"],
  directives: {
    'click-outside': {
      bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
          // Check that the clicked element is not within the menu container
          if (!(el === event.target || el.contains(event.target))) {
            // Call the specified method
            vnode.context[binding.expression]();
          }
        };
        document.body.addEventListener('click', el.clickOutsideEvent);
      },
      unbind: function (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent);
      }
    }
  },
  mixins:[i18nComponentMixin('views/B2bLayout')],
  data: function () {
    return {
      showDiscover: true,
      showPopup: false,
      navDownImage: navDownImage,
      isMain: false,
      mainPages: ["Main", "Discover", "b2b-challenges"],
      showCorpItems: true,
      hideB2BLayoutOn: [
        'Trainer Profile',
      ],
      isLandscape: true,
      contentWidth: { width: '100%', 'margin-right': '0px', 'margin-left': '97px' },
      friendsActivityLabel: '',
      searchText: '',
      user: false,
      isActive: false,
      showAchievements: false,
      titles: [],
      desktopBanner: "",
      screen: 0,
      absoluteTrue: true,
      mobileBanner: "",
      bannerLink: "",
      showChallengesBanner: false,
      challengesBanner: "",
      mobileChallengesBanner: "",
      showNotifcation: true,
      NotificationData: [],
      BigCrossIcon: BigCrossIcon,
      isPhysiotherapy: false,
      lang: 'en',
      paymentLoading: false,
    };
  },
  watch: {
    $route: "routeData",
    isCorporate() {
      setTimeout(this.handleOrientationChange, 200);
    },
    searchVideoText(val) {
      this.searchText = val || '';
    }
  },
  components: {
    LanguageSwitcher,
    CodeInput,
    ImageBanner,
    TryPopup,
    Popup,
    UpgradeAccountPopup,
    ScrollMonitor,
    HeaderDropdown
  },
  filters: {
    getDayFormat(val) {
      let currentDate = new Date();
      let workoutDate = new Date(val);
      let daysDiff = Math.abs(currentDate.getTime() - workoutDate.getTime()) / 36e5;
      if (daysDiff < 12) {
        return "Today"
      } else if (daysDiff < 36) {
        return "Yesterday"
      }
      return workoutDate.getDate() + " " + monthList[workoutDate.getMonth()]
    },

    limitTitle(val) {
      if (val.length > 25) {
        return val.substring(0, 25).concat("...");
      } else {
        return val
      }
    },

    limitName(val) {
      if (val.length > 7) {
        return val.substring(0, 8).concat("...");
      } else {
        return val
      }
    }
  },
  methods: {
    ...challengesActions(["setChallengePage", "loadTenantData", "loadTeamsActivity"]),
    ...b2bActions(["setIsTitle", "setTitle", "setIsBackButton", "setPageName"]),
    ...b2bTrainerActions(['setShowLeaderboard']),
    ...mapDashboardAction(["fetchAutocompleteSearchResults"]),
    ...mapDashboardMutations(['setSearchText']),
    ...mapThemeMutations(['setTheme']),
    ...mapActions(["setUnreadCount"]),
    upgradeAccount() {
      this.$store.commit('setShowAccessOptions', {
        onCancelReturn: false
      });
    },
    onBottom() {
      const onBottomFun = this.$refs.routerViewRef?.onBottom;
      if (typeof onBottomFun === 'function') onBottomFun();
    },
    routeData(val) {
      this.isMain = this.mainPages.includes(val.name) ? true : false;
    },
    handleOrientationChange() {
      if (this.isMobile) {
        this.isLandscape = window.screen.availHeight < window.screen.availWidth;
      }
      this.handleContentWidthChange();
    },
    handleContentWidthChange() {
      /**check left sidebar
       * Refactoring {'margin-left': !isLandscape || hideB2BLayout ? '0px' : '97px'},
       */
      if (!this.isLandscape || this.hideB2BLayout) this.contentWidth['margin-left'] = '0px';
      else this.contentWidth['margin-left'] = '97px';
      /**
       * check right sidebar
       */
      const friendsActivityBar = document.getElementById("friend-activity");
      if (friendsActivityBar && !this.isPhysiotherapy) {
        if (window.getComputedStyle(friendsActivityBar).getPropertyValue('display') == "none")
          this.contentWidth['margin-right'] = '0px';
        else this.contentWidth['margin-right'] = '200px';
      } else this.contentWidth['margin-right'] = '0px';
      /** calculate width
      */
      this.contentWidth['width'] = `calc(100% - ${this.contentWidth["margin-right"]} - ${this.contentWidth['margin-left']})`
    },
    getSimilargetCategoriesVideos(catId) {
      this.$router.push(
        `/categories/${catId}`
      );
    },
    autocompleteText: debounce(function () {
      this.fetchAutocompleteSearchResults(this.searchText)
        .then(_ => {
          let arr = [];
          this.autocompleteSearchResults ? this.autocompleteSearchResults.map(result => {
            const obj = {
              id: result.id,
              title: result.title,
              category: result.category,
              tenantId: result.tenant_id,
              tenantName: result.tenant_name,
              isLocked: result.isLocked,
              lockedType: result.lockedType,
              thumbnail: result.thumbnail
            }
            arr.push(obj);
            this.titles = arr;
          }) : [];
          // clear out suggested titles if no video's found
          if (this.autocompleteSearchResults && this.autocompleteSearchResults.length === 0)
            this.titles = [];
        })
    }, 100), // Set the desired throttle time in milliseconds
    goToVideo(video) {
      // const {id, tenantName, tenantId, isLocked} = video;
      // if (isLocked) return;
      // this.$router.push(
      //     `/workout/${tenantName.replaceAll(/\s/g, "")}?id=${id}&tryNow=true`
      // );
      this.searchText = video.title;
      this.submit();
    },
    submit() {
      // send search request if any text is present
      if (this.searchText) {
        this.setSearchText(this.searchText);
        this.isActive = false;
        // send to discover page
        if (this.$route.name !== 'Discover')
          this.$router.push({ name: 'Discover' }).catch(err => { });
      }
    },
    clearInput() {
      this.searchText = '';
      this.setSearchText(null);
      this.$refs.textSearchInputRef.focus();
    },
    closeSearch() {
      this.isActive = false;
    },
    openSearch() {
      // this.searchText = "";
      this.isActive = true;
    },
    async listOfUserNotification() {
      if (this.showNotifcation) {
        if (!this.isAnonymous) {
          this.NotificationData.length = 0;
          const userId = this.$store.state.userInfo.userId;
          const data = await API.loadUserNotification({ userId });

          const unreadNotifications = data.data.allUsernotification.filter((notification) => notification.status === 'sent')

          this.setUnreadCount(unreadNotifications?.length || 0)

          this.NotificationData = data.data.allUsernotification
        }
        this.showNotifcation = false;
      } else {
        this.showNotifcation = true;
      }
    },

    async updateNotificationStatus(notificationId) {
      await api.updateNotificationStatus({ notificationId, status: "clicked" });
      const userId = this.$store.state.userInfo.userId;
      const notifications = await API.loadUserNotification({ userId });

      const unreadNotifications = notifications.data.allUsernotification.filter((notification) => notification.status === 'sent')

      this.setUnreadCount(unreadNotifications?.length || 0)

      this.NotificationData = notifications.data.allUsernotification
    },

    async readAllNotifications() {
      const userId = this.$store.state.userInfo.userId;
      await api.updateNotificationStatus({ userId, status: "clicked" });
      const notifications = await API.loadUserNotification({ userId });

      const unreadNotifications = notifications.data.allUsernotification.filter((notification) => notification.status === 'sent')

      this.setUnreadCount(unreadNotifications?.length || 0)

      this.NotificationData = notifications.data.allUsernotification
    },

    hideUpgradeAccountPopup() {
      this.$store.commit('setShowAccessOptions', false);
    },
    lockedMessage(lockedType) {
      if (lockedType === 'corporate-subs-user-only')
        return `For subscribed trainers only.
        Contact your trainer to unlock more videos.`
      else
        return `For corporate only.
        Click to enter your access code to unlock more videos.`
    },
    onAccessCodePopupRequest(video) {
      let { isLocked, lockedType } = video;
      if (isLocked && lockedType === 'corporate-user-only') {
        this.$store.commit('setShowAccessOptions', {
          onCancelReturn: false
        });
      }
    },
  },
  computed: {
    ...challengesState(["isChallengePage", "tenantData", "friendsActivityData"]),
    ...b2bState(["isTitle", "title", "isBackButton", "pageName"]),
    ...trainerState(["isAccessCodeCancel"]),
    ...mapGetters(["isAdmin"]),
    ...mapDashboardState(["autocompleteSearchResults", "searchVideoText"]),
    ...mapThemeGetters(["theme", "pages"]),
    ...mapState(["unreadCount"]),
    askedForUpgradeAccountPopup() {
      return this.$store.state.showAccessOptions;
    },
    onCancelUpgradeAccountReturn() {
      return this.askedForUpgradeAccountPopup?.onCancelReturn ?? true;
    },
    corporateTheme() {
      return this.$store.state?.userInfo?.corporate?.theme;
    },
    isAnonymous() {
      if (this.$store.state.userInfo) {
        return this.$store.state.userInfo.isAnonymousUser;
      } else {
        return true;
      }
    },
    hasSocialAccess() {
      return this.$store.state?.userInfo?.corporate?.show_social;
    },
    hideSearch() {
      if (this.isPhysiotherapy) {
        return true;
      }
      const showOnPages = ['Discover'];
      const activePage = this.$route.name;
      return !showOnPages.includes(activePage)
    },
    showNotificationIcon() {
      const hideOnPages = ['Discover', 'b2b-programs']
      const activePage = this.$route.name;
      return !hideOnPages.includes(activePage) && (this.$store.state.userInfo?.corporate?.config?.b2bLayout?.showNotificationIcon ?? true)
    },
    isMobile() {
      const isAndroid = /Android/i.test(navigator.userAgent);
      const isiOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
      const isIpad = (/iPad/i.test(navigator.platform) || (/Macintosh/.test(navigator.userAgent) && 'ontouchend' in document));
      return isAndroid || isiOS || isIpad;
    },
    hideB2BLayout() {
      return (this.hideB2BLayoutOn.includes(this.$route.name) && this.isAnonymous);
    },
    isCorporate() {
      return !!this.$store.state.userInfo?.corporate;
    },
    corporateSubscription() {
      return this.$store.state.userInfo?.corporate?.subscription;
    },
    getCorporateName() {
      if (this.$store.state.userInfo?.corporate?.redirect_url) {
        return this.$store.state.userInfo?.corporate?.redirect_url;
      } else {
        return null;
      }
    },
    getCorporateImage() {
      if (this.$store.state.userInfo?.corporate?.profile_pic) {
        return this.$store.state.userInfo?.corporate?.profile_pic;
      } else {
        return null;
      }
    },
    brandColor() {
      if (this.$store.state.userInfo?.corporate?.banner_color) {
        const color = this.$store.state.userInfo?.corporate?.banner_color;
        return (typeof color === 'string') ? color : undefined;
      } else {
        return undefined;
      }
    },
    friendsActivityColor() {
      return this.$store.state.userInfo?.corporate.friends_activity_color
        ? this.$store.state.userInfo?.corporate.friends_activity_color : '#141513';
    },
    hideFriendsActivity() {
      if (this.hideB2BLayout || !this.isCorporate || this.isMobile) return true;

      const config = this.$store.state.userInfo?.corporate?.config || {};
      if ("hideFriendsActivity" in config) return config.hideFriendsActivity;
      else return this.isPhysiotherapy;
    },
    computedBanner() {
      if (this.$route.path) {
        return this.$store.state?.userInfo?.corporate?.config?.bannerUrl;
      }
      else if (this.$route.path === '/user/challenges') {
        return this.$store.state?.userInfo?.corporate?.config?.challengeBannerUrl;
      }
      return null;
    },
    isUserEmailVerified() {
      return !!this.$store.state?.userInfo?.isEmailVerified;
    },
    language() {
      const savedLanguage = localStorage.getItem('lang');
      if (savedLanguage) {
        return savedLanguage;
      }
      return this.$store.state?.userInfo?.corporate?.config?.loginConfig?.language || 'en';
    },
    // showLanguageDropdown() {
    //   const defaultLanguage = this.$store.state?.userInfo?.corporate?.config?.loginConfig?.language || 'en';
    //   return defaultLanguage !== 'en';
    // },
  },
  async mounted() {
    this.$root.$on("show-notification-popup",async () => {
      this.$nextTick(async ()=>{
        if (this.$refs.notificationDropdown) {
          this.$refs.notificationDropdown.show();
          await this.listOfUserNotification()
        }       
      })
    });

    this.setTheme(this.corporateTheme);
    this.user = !this.$store.state.userInfo?.corporate?.config?.is_assessment;
    this.screen = window.screen.width;
    window.addEventListener('resize', () => {
      this.screen = window.screen.width
      let division = document.querySelector(".dynamic_changes")
      if (division && division.getBoundingClientRect().top > 5) {
        this.absoluteTrue = false
      } else {
        this.absoluteTrue = true
      }
    });
    // remove temporarily
    // if (!this.isUserEmailVerified && this.$route.name !== 'VerifyUser')
    //   this.$router.push({ name: 'VerifyUser' });

    // Get the corporate configurations from state
    const userInfo = this.$store.state.userInfo;
    this.showAchievements = !!userInfo?.corporate?.config?.showAchievements;
    this.isPhysiotherapy = userInfo?.corporate?.theme === "physiotherapy";
    if (this.isPhysiotherapy) {
      this.setIsTitle(true);
      this.setTitle('');
    }
    if(this.$route.path.includes('/assessment') && this.user){
      this.showPopup = true;
    }
    if (userInfo && userInfo.corporate) {
      const corporateConfig = userInfo.corporate.config;

      //Set language
      this.lang = this.language;

      // Check if required key-value is present in the configuration
      this.showDiscover = corporateConfig?.tabs?.discover ?? true;
      this.friendsActivityLabel = corporateConfig?.labels?.friendActivity ?? 'Friend Activity';

      // banner for the corporate on main page
      this.desktopBanner = this.$route.path == '/user/challenges' ? userInfo.corporate?.config?.challengeBannerUrl : userInfo.corporate?.config?.bannerUrl;
      this.mobileBanner = this.$route.path == '/user/challenges' ? userInfo.corporate?.config?.challengeMobileBannerUrl : userInfo.corporate?.config?.mobileBannerUrl;
      this.bannerLink = userInfo.corporate?.config?.bannerLink;
      this.showChallengesBanner = !!userInfo.corporate?.config?.showChallengesBanner;
    }
    this.isActive = this.search ? true : false;
    this.searchText = this.search;

    this.tenantName = this.getCorporateName;
    this.handleOrientationChange();
    window.addEventListener("resize", this.handleOrientationChange, false);
    if (this.tenantName) {
      await this.loadTenantData(this.tenantName);
    }
    // If not valid tenant found then redirect to 404 page
    // else {
    //   this.$router.push({ name: "Not Found" });
    // }
    document.title = "EliteFit.AI - " + this.tenantData?.name ?? "Main";

    /**
     * IF Tenant page is corporate Micro-Site, Check if the user is a corporate user
     * */
    if (this.isCorporate) {
      if (this.isAnonymous) {
        this.$router.push({ path: `/${this.tenantName}/sign-up` });
      } else {
        const corporateUserAccessResp = await api.verifyUser({
          tenant_id: this.tenantData.id,
        });

        if (corporateUserAccessResp.code == 200) {
          this.setShowLeaderboard(true);
          await this.loadTeamsActivity();
        }
        else {
          this.showCorpItems = false;
          this.setShowLeaderboard(false);
          if (!this.isAccessCodeCancel) {
            this.$router.push({ path: `/${this.tenantName}` });
          }
        }
      }
    }
    this.routeData({ name: "Main" });
    
  },
  beforeDestroy() {
    this.$root.$off("show-notification-popup");
  },
};
</script>
<style lang="scss" scoped>
html,
body {
  height: 100%;
  width: 100%;
  margin: 0;
}

.cover{
  position: absolute;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(1px);
  width: 100%;
  display: flex;
  justify-content: center;
  padding-top: 10px;

  svg {
      fill: #73bc44;
      width: 30px;
      height: 30px;
  }
}

.router-view {
  position: relative;
}

.buy-plan-button {
  display: flex;
  align-items: center;
  margin: 8px;
  white-space: nowrap;

  .btn {
    background-color: #75BC45;
    color: white !important;
  }

  .btn:disabled {
    background-color: grey;
    border-color: grey;
  }

  .btn:focus,
  .btn:active,
  .btn:hover {
    outline: none !important;
    text-decoration: none;
  }
}

.nav-item {
  list-style-type: none;
}

.header-item {
  padding: 4px 12px;
  border-radius: 6px;
}


.border-green {
  border: 1px solid;
  width: auto;
  border-color: #73bc44;
}

.nav-wrapper {
  width: 97px;
  position: fixed;
  top: 0;
  left: 0;
  border-radius: 0px 16px 16px 0px;
}

.mobile-nav-wrapper {
  height: 65px;
  position: fixed;
  bottom: 0;
  left: 0;
  border-radius: 12px 12px 0px 0px;
}

.nav-wrapper .nav-link {
  padding: 0px;
}

.Position-fixed {
  position: fixed !important;
  right: 0;
}

.Right {
  right: 200px !important;
}

.content-menu {
  // margin-right: 200px;
  top: 0;
  height: 100%;
  position: fixed;
}

.friend-activity {
  display: none;
  width: 200px;
  font-size: 10px;
  top: 0;
  right: 0;
  position: fixed;
  right: 0;
  border-radius: 16px 0px 0px 16px;
}

.nav-wrapper .nav-link p {
  font-size: 12px;
  line-height: 18px;
  font-family: Poppins;
  font-style: normal;
}

.mobile-nav-wrapper .nav-link img {
  width: 20px !important;
}

.mobile-nav-wrapper .nav-item {
  padding: 0 !important;
  margin: 0 !important;
}

.mobile-nav-wrapper .nav-link {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  color: #969b92;
}

.mobile-nav-wrapper .nav-link.active,
.mobile-nav-wrapper .nav-link:hover {
  color: #73bc44;

  .home {
    svg {
      path {
        fill: #73bc44 !important;
        fill-rule: "evenodd";
        clip-rule: "evenodd";
        stroke-width: 0;
      }
    }

    .menu-text {
      font-weight: 700;
    }
  }

  .leaderboard {
    svg {
      path {
        fill: #73bc44 !important;
      }
    }

    .menu-text {
      font-weight: 700;
    }
  }

  .progress-tab {
    svg {
      path {
        fill: #73bc44 !important;
      }
    }

    .menu-text {
      font-weight: 700;
    }
  }

  .social-tab {
    svg {
      path {
        fill: #73bc44 !important;
      }
    }
  }
}

.mobile-nav-wrapper .nav-item p {
  padding: 0 !important;
  margin: 0 !important;
  margin-top: 0.5rem !important;
  font-family: Poppins;
  font-style: normal;
}

.content-menu .nav-link:hover label {
  color: #73bc44;
}

.content-menu .text-active.active label {
  color: #73bc44;
}

.profile-img {
  width: wrap !important;
  height: wrap !important;
  max-width: 100%;
  max-height: 70%;
  box-shadow: 0px 16px 49px rgba(20, 21, 19, 0.15);
  border-radius: 100px;
  background-color: #f9f9f9;
}

.dropdown-icon {
  width: 10%;
}

.content-wrapper {
  width: 100%;
  height: 100%;
  position: relative;
  flex: 1;
  overflow-y: scroll !important;
  background-color: #f4f6f9 !important;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.content-wrapper-bottom {
  margin-bottom: 65px !important;
}

.content-wrapper::-webkit-scrollbar {
  display: none;
}

::v-deep .profile-img .dropdown-menu.show {
  background-color: white !important;
}

::v-deep .profile-img .dropdown .nav-link {
  color: #73bc44 !important;
}

::v-deep .profile-img .dropdown span {
  color: #141513 !important;
}

::v-deep .nav-wrapper .nav-link:hover {
  color: #73bc44;
}

::v-deep .nav-wrapper .nav-link.active {
  color: #73bc44;

  .home {
    svg {
      path {
        fill: #73bc44 !important;
        fill-rule: "evenodd";
        clip-rule: "evenodd";
        stroke-width: 0;
      }
    }

    .menu-text {
      font-weight: 700;
    }
  }

  .leaderboard {
    svg {
      path {
        fill: #73bc44 !important;
      }
    }

    .menu-text {
      font-weight: 700;
    }
  }

  .progress-tab {
    svg {
      path {
        fill: #73bc44 !important;
      }
    }

    .menu-text {
      font-weight: 700;
    }
  }

  .social-tab {
    svg {
      path {
        fill: #73bc44 !important;
      }
    }
  }
}

::v-deep .nav-wrapper .nav-link {
  color: #969b92;

  //background-color: #141513;
  .home {
    .menu-text {
      font-weight: 500;
    }
  }

  .leaderboard {
    .menu-text {
      font-weight: 500;
    }
  }

  .progress-tab {
    .menu-text {
      font-weight: 500;
    }
  }
}

::v-deep .profile-img .dropdown .dropdown-item {
  color: #73bc44 !important;
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  background-color: white !important;
}

::v-deep .profile-img .dropdown-toggle {
  color: #73bc44 !important;
}

.search-icon {
  height: 40px;
  width: 40px;
  background-color: #73bc44;
  min-width: 40px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 40px !important;
}

.notification-dropdown .search-icon {
  padding: 10px;
  height: 40px;
  width: 40px;
}

.notification-dropdown-menu .dropdown-menu.show {
  background-color: transparent !important;
}

.search-icon-close {
  height: 45px;
  width: 45px;
  min-width: 45px;
  background-color: #73bc44;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px 20px;
  border-radius: 0 100px 100px 0 !important;
}




.serach-open {
  display: none;
}

.serach-open .form-group {
  display: flex;
  align-items: center;
  justify-content: center;
}

.serach-open .form-control {
  height: 45px;
  width: 250px;
}

.search-bar {
  z-index: 9999 !important;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: end;
  max-width: 400px;
  width: 100%;
}

.total_right {
  position: absolute;
  right: calc(100% - 3rem);
}

.draged {
  top: .25rem;
  padding-right: 16px;
}

.notification-dropdown {
  display: flex;
  align-items: center;
  justify-content: center;
}

.notification-dropdown-menu {
  .notification-width {
    width: 30rem;
  }


.notification-card {
  width: 600px;
  height: 450px;
  margin: 0 auto;
}

::v-deep .dropdown-menu.show {
  background-color: transparent !important;
  border: 0;
}

.card-item {
  transition: transform 0.3s, background-color 0.3s;
}

.card-item.unread {
  border-left: 5px solid #73bc44
}

.card-header {
  background-color: #73bc44
}

.card-item.read {
  border-left: 5px solid #72787e;
}

.card-subtitle {
  color: #212529;
}

.card-text {
  font-size: 0.9rem;
  color: #73787c;
}

.btn-primary {
  font-size: 0.8rem;
  color: #fff !important;
  background-color: transparent !important;
  padding: 0.3rem 0.6rem;
  width: auto !important;
  border: none !important;
}

.bg-success-subtle {

  background-color: #8ec63f1f;
}
}

.list-group-item {
  position: relative;
  min-height: 62px;

  label {
    left: 40%;
    position: relative;
    word-wrap: break-word;
    width: 60%;
  }
}

.thumbnail-dis {
  top: 0;
  left: 0;
  height: 100%;
  min-height: 50px;
  width: 40%;
}

.search-input {
  position: absolute;
  right: 45px;
  top: 12px;
  height: 25px;
  width: 25px;
  font-size: 16px;
  font-weight: 600;
  color: #73bc44;
  cursor: pointer;
}

.form-group {
  position: relative;
}

// need to block
.serach_open_block {
  display: flex;

}

// need close
.search_icon_hide {
  display: none;
}


.list-group {
  // top: -21px;
  position: absolute;
  width: 250px;
  left: 0px;
  right: auto;
  top: 45px;
  bottom: auto;
  z-index: 99;
}

.translate-dropdown {
  padding-top: 10px;
  padding-left: 40px;

  .translate-select {
    cursor: pointer;
  }
}

// Mobile Landscape
@media (max-width: 768px) {
  .profile-img {
    background-color: none;
    box-shadow: none !important;
  }

  .nav-item b {
    font-size: 14px !important;
  }

  .search-bar {
    z-index: 9999 !important;
    position: fixed;
    right: 20px;
    bottom: 80px;
    z-index: 999;
    max-width: unset;
    width: unset;
    justify-content: flex-end;
  }

  .serach-open .form-control {
    min-width: 250px
  }

  .list-group {
    position: absolute;
    width: 250px;
    right: 44px;
    top: auto;
    left: auto;
    bottom: 40px;
  }
}

// Mobile Portrait
@media screen and (max-width: 480px) {
  .content-menu {
    margin-left: 0% !important;
    width: 100% !important;
  }

  .nav-item b {
    font-size: 14px !important;
  }

  .notification-dropdown-menu {
    .notification-card {
      width: calc(100vw - 10px);
    }
  }
}

// Very small mobile screen
@media screen and (max-width: 330px) {
  .nav-item b {
    font-size: 12px !important;
  }

  .content-menu .nav-link {
    padding-left: 5px !important;
    padding-right: 5px !important;
  }
}

.z10 {
  z-index: 10;
  position: relative;
}

.notification-dropdown .notification-btn {
  background: transparent;
  outline: none;
  border: none;
}

.notification-badge {
  position: absolute;
  top: -1px;
  right: 6px;
  background-color: #ff0000;
  color: white;
  border-radius: 50%;
  padding: 4px 11px;
  font-size: 12px;
  font-weight: bold;
}

.notification-dropdown .notification-btn svg {
  width: 30px !important;
}

.notification-dropdown .card .card-title {
  padding: 15px 20px;
  margin: 0;
}

.notification-dropdown .card .card-body {
  padding: 40px 20px;
  padding: 40px 20px;
  height: 300px;
  overflow: auto;
}

.notification-dropdown .card .card-body .card-item {
  border-bottom: 1px solid #dcdcdc;
  border-top: 1px solid #dcdcdc;
  margin-bottom: 20px;
  .card-subtitle{
    padding-top: 10px;
    padding-left: 5px;
  }
  .card-text{
    padding: 5px;
  }
}

.notification-dropdown .dropdown-menu {
  border-radius: 20px;
  border: none;
  background-color: transparent !important;
}


.popup-top-layer {
  position: relative;
  width: 570px;
  height: 342px;
  margin: auto;
  border-radius: 15px;
  overflow: hidden;

  .popup-background-layer {
    &.background {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #ffffff;
    }

    &.popup {
      position: relative;
      width: 100%;
      height: 100%;
      z-index: 1;
    }
  }

  .popup-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;

    .left-container {
      height: 100%;

      img {
        max-height: 100%;
      }
    }

    .right-container {
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      justify-content: center;
      align-items: center;
      text-align: center;
      padding: 5px 16px 20px 16px;
      margin-top: 35px !important;

      .top-section-container {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        justify-content: flex-start;
        align-items: center;
        text-align: center;
        color: #000000;

        .heading-desktop {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          margin: 5px auto;

          img {
            max-width: 124px;
            max-height: 118px;
          }

          .heading-text {
            display: flex;
            flex-direction: column;

            h2 {
              padding-left: 0px;
              font-size: 25px;
              font-weight: 700;
              margin-bottom: 0 !important;
              line-height: 38px;
              letter-spacing: 0em;
              text-align: center;

            }
          }
        }

        .subtitle-text {
          p {
            font-size: 18px;
            font-weight: 400;
            line-height: 27px;
            letter-spacing: 0em;
            text-align: center;

          }
        }
      }

      .try-now-button,
      .try-now-button:hover {
        background: #FFFFFF;
        border-radius: 25px;
        width: 179px;
        max-width: 400px;
        font-weight: 700;
        font-size: 20px;
        line-height: 30px;
        color: #000000;
        display: inline-block;
        text-decoration: none;
        border: 1px solid #000000;
        box-shadow: 4px 4px 6px rgba(0, 0, 0, 0.25);
      }

      .cancel-button {
        margin-top: 1em;
        background-color: inherit;
        border-radius: 25px;
        width: 100px;
        height: 39px;
        max-width: 400px;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        text-align: center;
        color: #FFFFFF;
        display: inline-block;
        text-decoration: none;
        border-width: 0;
      }

      .cancel-button:hover {
        color: red;
      }

      .do-not-remind {
        color: #FFFFFF;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        letter-spacing: 0em;
        text-align: center;

      }
    }
  }
}

.popup-mobile-dim {
  margin-top: 15%;
  width: 500px;
  height: 400px;
  border-radius: 15px;
  overflow: hidden;

  .popup-container-mobile {
    flex-direction: column;

    img {
      max-width: 100%;
      max-height: 145px;
      margin: auto;
    }
  }

  .bottom-container {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    justify-content: flex-start;
    align-items: center;
    text-align: center;
    padding: 5px 21px 20px 16px;
    margin-top: 0px !important;

    .top-section-container {
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      justify-content: flex-start;
      align-items: center;
      text-align: center;
      color: #000000;

      .heading-desktop {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin: 5px auto;

        img {
          max-width: 124px;
          max-height: 118px;
        }

        .heading-text {
          display: flex;
          flex-direction: column;

          h2 {
            padding-left: 0px;
            font-weight: 700;
            margin-bottom: 0 !important;
            font-size: 32px;
            line-height: 48px;
            letter-spacing: 0em;
            text-align: center;
          }
        }
      }

      .subtitle-text {
        p {
          font-size: 18px;
          font-weight: 400;
          line-height: 24px;
          text-align: center;

        }
      }
    }

    .try-now-button,
    .try-now-button:hover {
      background: #8DC63F;
      border-radius: 25px;
      width: 179px;
      max-width: 400px;
      font-weight: 700;
      font-size: 20px;
      line-height: 30px;
      color: #ffffff;
      display: inline-block;
      text-decoration: none;
      border: 1px solid #000000;
      box-shadow: 4px 4px 6px rgba(0, 0, 0, 0.25);
    }
  }
}

.locked-cover {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background: rgba(0, 0, 0, 0.5);
  pointer-events: all;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  text-align: center;

  .lock-icon {
    font-size: 200%;
  }
}
</style>
